// The Django template sets window.context before the bundle loads.
// We read it once and export it as a typed constant.
export const appContext = window.context;
